//Imagen
import banner380 from '../../../Activos/Imagenes/BannerHome/banner380.svg';

export const ComponenteExtra380Style = {
    DivStyle: {
        display: 'flex',
        justifyContent: 'center',
        backgroundImage: 'url(' + banner380 + ')',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        alignItems: 'center',
        gap: 20,
        height: 70,
        width: 'auto'
    },
    TittleTextStyle: {
        color: '#FFFFFF',
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: 700,
        letterSpacing: '0px'
    },
    ImgStyle: {
        width: '171px',
        height: '29px',
    },
};